import { render, staticRenderFns } from "./126.vue?vue&type=template&id=70cee881&scoped=true&"
var script = {}
import style0 from "./126.vue?vue&type=style&index=0&id=70cee881&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cee881",
  null
  
)

export default component.exports